// 引入axios（axios进行二次封装）
import request from '@/utils/request'

// 对外暴露登录接口函数
export function login(data) {
  return request({
    url: '/system/api/admin/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/system/api/admin/getAdminInfoByToken',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/system/api/admin/logout',
    method: 'get'
  })
}

// 获取图形验证码
export function getImgCode() {
  return request({
    url: '/system/api/admin/validate/code/get',
    method: 'get'
  })
}

// 修改密码
export function updatePwd(data) {
  return request({
    url: '/system/api/admin/updatePwd',
    method: 'post',
    data
  })
}

// 发送验证码
export function emailSend(data) {
  return request({
    url: '/system/api/admin/email/send',
    method: 'get',
    params: data
  })
}

// 获取登录用户可访问目录
export function getMenus() {
  return request({
    url: '/system/api/admin/getMenus',
    method: 'get'
  })
}

// 用户绑定角色
export function userBindRole(data) {
  return request({
    url: '/system/api/admin/user/bindRole',
    method: 'post',
    data
  })
}

// 修改邮箱
export function updateEmail(data) {
  return request({
    url: '/system/api/admin/updateEmail',
    method: 'post',
    data
  })
}

// 修改备注
export function updateRemake(data) {
  return request({
    url: '/system/api/admin/updateRemake',
    method: 'post',
    data
  })
}

// 修改时区
export function updateTimeZone(data) {
  return request({
    url: '/system/api/admin/updateTimeZone',
    method: 'post',
    data
  })
}

// 登录获取演示账号
export function queryDemoAccountList() {
  return request({
    url: '/system/api/admin/demoAccount/queryDemoAccountList',
    method: 'get'
  })
}

// 保存演示账号
export function demoAccountSave(data) {
  return request({
    url: '/system/api/admin/demoAccount/save',
    method: 'post',
    data
  })
}

// 删除演示账号
export function demoAccountDalete(data) {
  return request({
    url: '/system/api/admin/demoAccount/delete',
    method: 'post',
    data
  })
}

// 查询演示账号
export function demoAccountQueryList() {
  return request({
    url: '/system/api/admin/demoAccount/queryList',
    method: 'get'
  })
}

// 获取厂商客服
export function mcsQueryList() {
  return request({
    url: '/system/api/admin/mcs/queryList',
    method: 'get'
  })
}

// 保存厂商客服
export function mcsEdit(data) {
  return request({
    url: '/system/api/admin/mcs/edit',
    method: 'post',
    data
  })
}

// 删除厂商客服
export function mcsDelete(data) {
  return request({
    url: '/system/api/admin/mcs/delete',
    method: 'post',
    data
  })
}
